import './index.css';

export const TextProfileIcon = ({ text, isOnline = false }) => {

  const shortName = text.split(' ').map(name => name[0]).join('');

  return (
    <div className="text-profile-icon">
      <span>{shortName.toUpperCase()}</span>
      {isOnline && <div className="online-status" />}
    </div>
  );
};